import { getUserData } from "./helpers/user";
export function initializeCart(store) {
  let nlUser = getUserData();
  if (nlUser) {
    store.commit('CartModule/setCartData', nlUser.cartData);
  }
}

export function initializeAuth(store) {
  let nlUser = getUserData();
  if (nlUser) {
    store.commit('AuthModule/setUser', nlUser.user);
  }
}

export function initializeApp(store) {
  let nlUser = getUserData();

  console.log("initializeApp",nlUser);
  if (nlUser) {
    store.commit('AuthModule/initUserData', nlUser.user);
    store.commit('CartModule/setCartData', nlUser.cartData);
  }
}